// extracted by mini-css-extract-plugin
module.exports = {"container":"_2iqC4","back-office":"InkRJ","backOffice":"InkRJ","success":"_3IWSl","error":"ZXf5-","info":"_2PJG7","center":"_19AhX","static":"_1a8Rv","close":"_3RUSI"};